var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSliderLong = function SvgSliderLong(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.667 0C6.425 0 5.381.85 5.085 2H1a.667.667 0 0 0 0 1.333h4.084c.296 1.15 1.34 2 2.582 2h.667a2.667 2.667 0 1 0 0-5.333h-.667ZM12.334 2a.667.667 0 1 0 0 1.333h.667A.667.667 0 0 0 13 2h-.667ZM5 6.667c-1.242 0-2.286.85-2.582 2H1.001A.667.667 0 1 0 1 10h1.417c.296 1.15 1.34 2 2.583 2h.666a2.667 2.667 0 1 0 0-5.333h-.666ZM9.667 8.667a.667.667 0 1 0 0 1.333h3.334a.667.667 0 0 0 0-1.333H9.667Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSliderLong);
export default ForwardRef;